module.exports = __webpack_public_path__ + "static/media/sk_swiper_c-10.fccbba7c.png";